import { render, staticRenderFns } from "./Searches.vue?vue&type=template&id=52545c73&scoped=true&"
import script from "./Searches.vue?vue&type=script&setup=true&lang=js&"
export * from "./Searches.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52545c73",
  null
  
)

export default component.exports